export default "__VITE_ASSET__ddc552cb__"